/* eslint-disable react/prop-types */
import React from 'react';
// TODO: Remove react-bootstrap
// eslint-disable-next-line no-restricted-imports
import { Button, Modal } from 'react-bootstrap';
import classNames from 'classnames';
import styles from '../styles.css';

import {
  CATEGORY_DELETING_TITLE,
  CATEGORY_DELETING_MSG,
  CATEGORY_DELETING_YES,
  CATEGORY_DELETING_NO,
} from '../constants';

import Question from './Question';
import * as selectors from '../reducers';

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default class Category extends React.Component {
  constructor(props) {
    super(props);
    this.state = { name: props.category.name, showModal: false };
  }

  // Handle category level callbacks:

  handleEditCategory = () => {
    const { category, callbacks } = this.props;
    callbacks.editCategory(category);
  };

  handleEditing = (e) => {
    this.setState({ name: e.target.value });
  };

  handleSaveCategoryEdit = () => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    categoryJS.name = this.state.name;
    callbacks.saveCategoryEdit(categoryJS);
  };

  handleCancelCategoryEdit = () => {
    const { category, callbacks } = this.props;
    callbacks.cancelCategoryEdit(category);
  };

  handleAddQuestion = () => {
    const { category, callbacks } = this.props;
    callbacks.addQuestion(category);
  };

  handleDeleteCategory = () => {
    const { category, callbacks } = this.props;
    callbacks.deleteCategory(category);
    this.handleHideModal();
  };

  handlePublishCategory = () => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    categoryJS.publish = !categoryJS.publish;
    callbacks.publishCategory(categoryJS);
  };

  handleMakeCategoryPublic = () => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    categoryJS.public = !categoryJS.public;
    callbacks.makeCategoryPublic(categoryJS);
  };

  handleExpandCategory = () => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    categoryJS.public = !categoryJS.public;
    callbacks.expandCategory(categoryJS);
  };

  handleCollapseCategory = () => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    categoryJS.public = !categoryJS.public;
    callbacks.collapseCategory(categoryJS);
  };

  // Handle question level callbacks:

  handleEditQuestion = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.editQuestion(categoryJS, questionJS);
  };

  handleSaveQuestionEdit = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.saveQuestionEdit(categoryJS, questionJS);
  };

  handleCancelQuestionEdit = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.cancelQuestionEdit(categoryJS, questionJS);
  };

  handlePublishQuestion = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.publishQuestion(categoryJS, questionJS);
  };

  handleMakeQuestionGlobal = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.makeQuestionGlobal(categoryJS, questionJS);
  };

  handleExpandQuestion = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.expandQuestion(categoryJS, questionJS);
  };

  handleCollapseQuestion = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.collapseQuestion(categoryJS, questionJS);
  };

  handleDeleteQuestion = (questionJS) => {
    const { category, callbacks } = this.props;
    const categoryJS = { ...category };
    callbacks.deleteQuestion(categoryJS, questionJS);
  };

  // Handle the simple dialog modal:

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleHideModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { category, generalOprs, categoryOprs, questionOprs } = this.props;

    if (!category) {
      return null;
    }

    const childCallbacks = {
      editQuestion: this.handleEditQuestion,
      saveQuestionEdit: this.handleSaveQuestionEdit,
      cancelQuestionEdit: this.handleCancelQuestionEdit,
      publishQuestion: this.handlePublishQuestion,
      makeQuestionGlobal: this.handleMakeQuestionGlobal,
      expandQuestion: this.handleExpandQuestion,
      collapseQuestion: this.handleCollapseQuestion,
      deleteQuestion: this.handleDeleteQuestion,
    };

    const questionNodes = category.questions.map((qst, idx) => (
      <div key={idx}>
        <Question
          question={qst}
          editPermission={category.edit_perm}
          generalOprs={generalOprs}
          categoryOprs={categoryOprs}
          questionOprs={selectors.getQuestionOprs(questionOprs, qst)}
          callbacks={childCallbacks}
        />
      </div>
    ));

    const categoryJS = { ...category };
    const isInEditing = categoryOprs ? categoryOprs.IN_EDITING : false;

    const editingNode = categoryJS.edit_perm ? (
      <div>
        <input
          className="form-control"
          style={!isInEditing ? { display: 'none' } : {}}
          value={this.state.name}
          onChange={this.handleEditing}
        />
        <button
          className={classNames(
            'btn',
            'btn-sm',
            'btn-success',
            styles['faq-question-button-save'],
          )}
          style={!isInEditing ? { display: 'none' } : {}}
          type="button"
          onClick={this.handleSaveCategoryEdit}
        >
          Save changes
        </button>
        <button
          className={classNames(
            'btn',
            'btn-sm',
            'btn-default',
            styles['faq-question-button-cancel'],
          )}
          style={!isInEditing ? { display: 'none' } : {}}
          type="button"
          onClick={this.handleCancelCategoryEdit}
        >
          Cancel
        </button>
      </div>
    ) : null;

    const buttonsNode = categoryJS.edit_perm ? (
      // TODO: Replace with a CSS Module class/id
      // eslint-disable-next-line no-inline-styles/no-inline-styles
      <div className="btn-group" style={{ marginTop: 10 }}>
        <button
          type="button"
          className="btn btn-xs btn-primary"
          onClick={this.handleAddQuestion}
        >
          Add question
        </button>
        <button
          type="button"
          className="btn btn-xs btn-danger category-delete-btn"
          disabled={categoryJS.publish}
          onClick={this.handleOpenModal}
        >
          Delete category
        </button>
        <button
          type="button"
          className="btn btn-xs btn-success category-publish-btn"
          onClick={this.handlePublishCategory}
        >
          {`${categoryJS.publish ? 'Unpublish' : 'Publish'} category`}
        </button>
        <button
          type="button"
          className="btn btn-xs btn-default category-privatise-btn"
          onClick={this.handleMakeCategoryPublic}
        >
          {`Make category ${categoryJS.public ? 'private' : 'public'}`}
        </button>
      </div>
    ) : null;

    return (
      <div className="faq-group">
        <h3
          onClick={categoryJS.edit_perm ? this.handleEditCategory : null}
          style={isInEditing ? { display: 'none' } : {}}
        >
          {categoryJS.name}
        </h3>
        {editingNode}
        <div
          className={classNames(`panel-group`, 'ui-sortable', {
            [styles.unpublished]: !categoryJS.publish,
            [styles.faqPrivate]: !categoryJS.public,
          })}
          id={`g_${categoryJS.group_id}`}
          data-group-id={categoryJS.group_id}
        >
          {questionNodes}
          {buttonsNode}
        </div>

        <Modal show={this.state.showModal} onHide={this.handleHideModal}>
          <Modal.Header closeButton={true}>
            <Modal.Title>{CATEGORY_DELETING_TITLE}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{CATEGORY_DELETING_MSG}</Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleHideModal}>
              {CATEGORY_DELETING_NO}
            </Button>
            <Button bsStyle={'primary'} onClick={this.handleDeleteCategory}>
              {CATEGORY_DELETING_YES}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
